import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import type { AnyRouter } from "@tanstack/react-router";
import { bindRouter } from "@/shared/lib/router/router";
import { reportReactError } from "./sentry";

/** Query string sempre como string (igual ao Next), sem o JSON.parse padrão do TanStack. */
export const routerSearchOptions = {
  parseSearch: (search: string) => Object.fromEntries(new URLSearchParams(search)),
  stringifySearch: (search: Record<string, unknown>) => {
    const qs = new URLSearchParams(search as Record<string, string>).toString();
    return qs ? `?${qs}` : "";
  },
};

/** Liga o router ao adapter do Next e monta a árvore em #root (app e console). */
export function renderRouter(router: AnyRouter): void {
  bindRouter(router);

  // Só em dev: permite dirigir a navegação por scripts de smoke test/devtools.
  if (import.meta.env.DEV) Object.assign(window, { __router: router });

  const container = document.getElementById("root");
  if (!container) throw new Error("#root não encontrado no index.html");

  createRoot(container, {
    onUncaughtError: reportReactError,
    onCaughtError: reportReactError,
    onRecoverableError: reportReactError,
  }).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
}
